module.exports = __webpack_public_path__ + "static/media/Sol.5425061c.svg";